import { useQuery } from '@tanstack/react-query';

import { BusinessMeaningsService } from '../services/business-meanings';

const split = [{ id: 'split', name: 'Split', vendorRequired: false, moneyDirection: 'ALL' }] as const;

export function useBusinessMeanings({ filterOutHidden }: { filterOutHidden: boolean } = { filterOutHidden: true }) {
  const { data, isLoading } = useQuery(
    ['business-meanings'],
    () => BusinessMeaningsService.getInstance().getBusinessMeaningsPage(),
    {
      select: (data) => ({
        forClassification: data.filter((b) => b.hideForManualClassification !== true).concat(split),
        forFiltering: data.concat(split),
      }),
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchOnMount: false,
    },
  );

  console.log({ data });

  return { businessMeanings: data, isLoading };
}
